import React, { useState } from "react";
import clsx from "clsx";
import moment from "moment-timezone";
import { useStyles } from "./ValetInventoryTable.styles";
import "../../ResponsiveTable/_responsive.table.css";
import useCurrentFacilityTimezone from "../../../hooks/useCurrentFacilityTimezone";
import ValetInventoryDetailDrawer from '../ValetInventoryDetailDrawer/ValetInventoryDetailDrawer'
import { PARKING_ACTIVITY_STATUS } from "../../../constants";

const getStatusLabel = (statusID) => {
  switch (statusID) {
    case PARKING_ACTIVITY_STATUS.VALET_ARRIVAL:
      return "Arrived";
    case PARKING_ACTIVITY_STATUS.VALET_REQUEST:
      return "Requested";
    case PARKING_ACTIVITY_STATUS.VALET_RETRIEVAL:
      return "Retrieved";
    case PARKING_ACTIVITY_STATUS.VALET_DELIVERY:
      return "Delivered";
    default:
      return "";
  }
};

const ValetInventoryTable = ({ results = [] }) => {
  const classes = useStyles();
  const { timeZone } = useCurrentFacilityTimezone();
  const [selectedCredential, setSelectedCredential] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const onRowClick = (result) => {
    setSelectedCredential(result);
    setDrawerOpen(true);
  }

  const onDrawerClose = () => {
    setSelectedCredential(null);
    setDrawerOpen(false)
  }

  return (
    <>
    <table className={clsx(classes.resultTable, "a1-responsive")}>
      <thead className={clsx(classes.thHeader)}>
        <tr>
          <th className={clsx([classes.resultHeader])}>Ticket Number</th>
          <th className={clsx([classes.resultHeader])}>Customer</th>
          <th className={clsx([classes.resultHeader])}>Guest Type</th>
          <th className={clsx([classes.resultHeader, "hide-in-mobile"])}>Rate</th>
          <th className={clsx([classes.resultHeader, "hide-in-mobile"])}>Entrance Time</th>
          <th className={clsx([classes.resultHeader, "hide-in-mobile"])}>Make</th>
          <th className={clsx([classes.resultHeader, "hide-in-mobile"])}>Model</th>
          <th className={clsx([classes.resultHeader, "hide-in-mobile"])}>Status</th>
        </tr>
      </thead>
      
      <tbody>
      {results.map((result, index) => (
              <tr key={result.credentialId} 
                className={clsx(['clickable-row'])} 
                onClick={() => onRowClick(result)} data-selected={result.contextID === selectedCredential?.contextID} 
                data-testid="clickable-row">
              <td data-column="Ticket Number" className={clsx([classes.column])}>
                {result.ticketNumber}
              </td>
              <td data-column="Customer" className={clsx([classes.column])}>
                {[result.firstName, result.lastName].filter(Boolean).join(" ")}
              </td>
              <td data-column="Guest Type" className={clsx([classes.column])}>
                {result.guestType}
              </td>
              <td data-column="Rate" className={clsx([classes.column, "hide-in-mobile"])}>
                {result.rate}
              </td>
              <td data-column="Entrance Time" className={clsx([classes.column, "hide-in-mobile"])}>
                <span>{moment.utc(result.entranceTime).tz(timeZone).format("MM/DD/YYYY h:mm A")}</span>
              </td>
              <td data-column="Make" className={clsx([classes.column, "hide-in-mobile"])}>
                {result.make}
              </td>
              <td data-column="Model" className={clsx([classes.column, "hide-in-mobile"])}>
                {result.model}
              </td>
              <td data-column="Status" className={clsx([classes.column, "hide-in-mobile"])}>
                {getStatusLabel(result.statusID)}
              </td>
            </tr>
          ))}
        </tbody>
    </table>
          <ValetInventoryDetailDrawer credential={selectedCredential} open={drawerOpen} onClose={(success) => onDrawerClose()} />
      </>
  );
};

export default ValetInventoryTable;
